import React from 'react';
import Legal from '../Legal';

const Terms = () => {
    return (
        <Legal title="Terms of Use" lastUpdated="January 1, 2026">
            <h3>1. Agreement to Terms</h3>
            <p>
                These Terms of Use constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you") and ARIVUNEST ("we," "us" or "our"),
                concerning your access to and use of the website as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the “Site”).
            </p>

            <h3>2. Intellectual Property Rights</h3>
            <p>
                Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site (collectively, the “Content”)
                and the trademarks, service marks, and logos contained therein (the “Marks”) are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws.
            </p>
            <p>
                The Content and the Marks are provided on the Site “AS IS” for your information and personal use only. Except as expressly provided in these Terms of Use, no part of the Site and no Content or Marks may be copied,
                reproduced, aggregated, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise exploited for any commercial purpose whatsoever, without our express prior written permission.
            </p>

            <h3>3. User Representations</h3>
            <p>
                By using the Site, you represent and warrant that:
            </p>
            <ul>
                <li>All registration information you submit will be true, accurate, current, and complete.</li>
                <li>You will maintain the accuracy of such information and promptly update such registration information as necessary.</li>
                <li>You have the legal capacity and you agree to comply with these Terms of Use.</li>
                <li>You are not a minor in the jurisdiction in which you reside.</li>
                <li>You will not access the Site through automated or non-human means, whether through a bot, script or otherwise.</li>
            </ul>

            <h3>4. Educational Content Disclaimer</h3>
            <p>
                The content provided on this platform is for educational purposes only. While ARIVUNEST strives to provide accurate and effective training methods,
                we do not guarantee specific employment outcomes, salary increases, or visa acceptances solely based on the completion of our courses.
                Fluency involves personal effort and practice outside of the platform environment.
            </p>

            <h3>5. User Registration</h3>
            <p>
                You may be required to register with the Site. You agree to keep your password confidential and will be responsible for all use of your account and password.
                We reserve the right to remove, reclaim, or change a username you select if we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable.
            </p>

            <h3>6. Modifications and Interruptions</h3>
            <p>
                We reserve the right to change, modify, or remove the contents of the Site at any time or for any reason at our sole discretion without notice.
                However, we have no obligation to update any information on our Site. We also reserve the right to modify or discontinue all or part of the Site without notice at any time.
            </p>
        </Legal>
    );
};

export default Terms;
